import { TitleCasePipe } from '@angular/common';
import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiUrls } from 'src/app/core/classes/ApiUrls';
import { CustomValidators } from 'src/app/shared/classes/CustomValidators';
import { Helper } from 'src/app/shared/classes/Helper';
import { HitApi } from 'src/app/shared/classes/HitApi';
import { ModalInjectedData } from 'src/app/shared/classes/ModalInjectedData';
import { AuthorizationType } from 'src/app/shared/enums/AuthorizationType';
import { ButtonColorType } from 'src/app/shared/enums/ButtonColorType';
import { ButtonType } from 'src/app/shared/enums/ButtonType';
import { FilterType } from 'src/app/shared/enums/FilterType';
import { FormState } from 'src/app/shared/enums/FormState';
import { RequestType } from 'src/app/shared/enums/RequestType';
import {
    IButtonGeneratorInput,
    IMultiButtonOption
} from 'src/app/shared/interfaces/button-generator/IButtonGeneratorInput';
import { IFormGeneratorInput } from 'src/app/shared/interfaces/form-generator/IFormGeneratorInput';
import { IHitApi } from 'src/app/shared/interfaces/hit-api/IHitApi';
import { FiltersService } from 'src/app/shared/services/filters/filters.service';
import { HttpService } from 'src/app/shared/services/http/http-main/http.service';
import { ModalService } from 'src/app/shared/services/modal/modal-service/modal.service';
import { MultiStepFormService } from 'src/app/shared/services/modal/multi-step-form/multi-step-form.service';
import { NotificationsService } from 'src/app/shared/services/notifications/notifications.service';
import { UserDataCacheService } from 'src/app/shared/services/user-data-cache/user-data-cache.service';
import { WhiteLabelingService } from 'src/app/shared/services/white-labeling/white-labeling.service';
import { Clouds } from './../../../../../enums/Clouds';
import { ListHttpService } from './../../../../../services/http/list-http/list-http.service';

@Component({
    selector: 'app-create-user-step-two',
    templateUrl: './create-user-step-two.component.html',
    styleUrls: ['./create-user-step-two.component.sass']
})
export class CreateUserStepTwoComponent implements OnInit {
    accountListFormGenInput: IFormGeneratorInput = null;
    accountListFormGroup: FormGroup;
    checkBoxFormGenInput: IFormGeneratorInput = null;
    checkBoxFormGroup: FormGroup;
    emailContentFormGenInputs: IFormGeneratorInput = null;
    emailContentFormGroup: FormGroup;
    emailSubject: string;
    emailContent: string;
    edit: boolean = false;
    stepData: any = null;
    selectedAwsAccountIds = [];
    selectedAzurePlanAccountIds = [];
    selectedAzureCspAccountIds = [];
    selectedAzureEaAccountIds = [];
    selectedAzureSponsorshipAccountIds = [];
    selectedPayAsYouGoAccountIds = [];
    selectedAzureMcaAccountIds = [];

    buttonGenInputs: IButtonGeneratorInput[] = [
        {
            buttonName: 'Back',
            buttonColorType: ButtonColorType.PRIMARY,
            buttonType: ButtonType.FLAT,
            function: () => {
                this.multiStepFormService.previousStep(
                    this.modalInputData.modalId
                );
            }
        },
        {
            buttonName: 'Create',
            buttonColorType: ButtonColorType.PRIMARY,
            buttonType: ButtonType.FLAT,
            showLoader: true,
            function: (buttonRef) => {
                this.edit
                    ? this.updateUser(buttonRef)
                    : this.createUser(buttonRef);
            }
        }
    ];

    buttonOptions: IMultiButtonOption = {
        layout: {
            justifyContent: 'space-between'
        }
    };

    constructor(
        public modalInputData: ModalInjectedData,
        private httpService: HttpService,
        private ngZone: NgZone,
        public multiStepFormService: MultiStepFormService,
        private notificationService: NotificationsService,
        private whiteLabelService: WhiteLabelingService,
        private userDataCacheService: UserDataCacheService,
        private modalService: ModalService,
        private filtersService: FiltersService,
        private cdr: ChangeDetectorRef,
        private listHttpService: ListHttpService
    ) {
        if (modalInputData && modalInputData.data && modalInputData.data.edit) {
            this.edit = true;
            this.stepData = this.modalInputData.data.userData;
            if (this.stepData['cloudAccounts']) {
                this.selectedAwsAccountIds =
                    this.stepData['cloudAccounts'][Clouds.AWS];
                this.selectedAzureCspAccountIds =
                    this.stepData['cloudAccounts'][Clouds.AZURE_CSP];
                this.selectedAzureEaAccountIds =
                    this.stepData['cloudAccounts'][Clouds.AZURE_EA];
                this.selectedAzurePlanAccountIds =
                    this.stepData['cloudAccounts'][Clouds.AZURE_PLAN];
                this.selectedAzureMcaAccountIds =
                    this.stepData['cloudAccounts'][Clouds.AZURE_MCA];
            }
        }
    }

    ngOnInit(): void {
        this.editContents();
        this.setUpBasis();
    }
    editContents() {
        const step1Data = this.multiStepFormService.stepData
            .get(this.modalInputData.modalId)
            .get(1);
        if (
            this.whiteLabelService &&
            this.whiteLabelService.whiteLableData &&
            this.whiteLabelService.whiteLableData.customerContent
        ) {
            this.emailSubject =
                this.whiteLabelService.whiteLableData.userSubject.replace(
                    /{{companyName}}/g,
                    this.whiteLabelService.whiteLableData.companyName
                );
            this.emailContent =
                this.whiteLabelService.whiteLableData.userContent.replace(
                    /{{companyName}}/g,
                    this.whiteLabelService.whiteLableData.companyName
                );

            const fullName = (
                step1Data.firstName +
                ' ' +
                (step1Data.lastName ? step1Data.lastName : '')
            ).trim();

            const titleCase = new TitleCasePipe().transform(fullName);

            this.emailContent = this.emailContent.replace(
                /{{user}}/g,
                titleCase
            );
            this.emailContent = Helper.replaceAll(
                this.emailContent,
                '{{email}}',
                step1Data.email
            );
            this.emailContent = Helper.replaceAll(
                this.emailContent,
                '{{password}}',
                step1Data.password
            );
            this.emailContent = Helper.replaceAll(
                this.emailContent,
                '{{domainName}}',
                location.href
            );
            this.emailContent = Helper.replaceAll(
                this.emailContent,
                '{{domainId}}',
                this.userDataCacheService.domainId
            );
        }
    }
    setUpBasis() {
        if (this.edit) {
            this.buttonGenInputs[1].buttonName = 'Update';
        }
        this.accountListFormGenInput = {
            formName: '',
            submitButton: null,
            state: this.edit ? FormState.EDIT : FormState.CREATE,
            fields: [
                {
                    label: 'AWS Account IDs',
                    placeholder: 'Select Aws Accounts',
                    name: Clouds.AWS,
                    fieldType: FilterType.DROPDOWN_GROUP_MULTIPLE,
                    groupBy: 'group',
                    required: false,
                    apiInfo: this.listHttpService.awsAccountIds,
                    value: this.edit ? this.selectedAwsAccountIds : null
                },
                {
                    label: 'Azure Csp Account IDs',
                    placeholder: 'Select Csp Accounts',
                    name: Clouds.AZURE_CSP,
                    fieldType: FilterType.DROPDOWN_GROUP_MULTIPLE,
                    groupBy: 'group',
                    required: false,
                    apiInfo: this.listHttpService.azureCspAccountIds,
                    value: this.edit ? this.selectedAzureCspAccountIds : null
                },
                {
                    label: 'Azure Ea Account IDs',
                    placeholder: 'Select Ea Accounts',
                    name: Clouds.AZURE_EA,
                    fieldType: FilterType.DROPDOWN_GROUP_MULTIPLE,
                    groupBy: 'group',
                    required: false,
                    apiInfo: this.listHttpService.azureEaAccountIds,
                    value: this.edit ? this.selectedAzureEaAccountIds : null
                },
                {
                    label: 'Azure Plan Account IDs',
                    placeholder: 'Select Plan Accounts',
                    name: Clouds.AZURE_PLAN,
                    fieldType: FilterType.DROPDOWN_GROUP_MULTIPLE,
                    groupBy: 'group',
                    required: false,
                    apiInfo: this.listHttpService.azurePlanAccountIds,
                    value: this.edit ? this.selectedAzurePlanAccountIds : null
                },
                {
                    label: 'Azure Mca Account IDs',
                    placeholder: 'Select Mca Accounts',
                    name: Clouds.AZURE_MCA,
                    fieldType: FilterType.DROPDOWN_GROUP_MULTIPLE,
                    groupBy: 'group',
                    required: false,
                    apiInfo: this.listHttpService.azureMcaAccountIds,
                    value: this.edit ? this.selectedAzureMcaAccountIds : null
                },
                {
                    label: 'Azure Sponsorship',
                    placeholder: 'Select Sponsorship  Accounts',
                    name: Clouds.SPONSORSHIP,
                    fieldType: FilterType.DROPDOWN_GROUP_MULTIPLE,
                    groupBy: 'group',
                    required: false,
                    apiInfo: this.listHttpService.sponsorshipAccountIds,
                    value: this.edit
                        ? this.selectedAzureSponsorshipAccountIds
                        : null
                },
                {
                    label: 'Azure Pay As You Go',
                    placeholder: 'Select Pay As You Go Accounts',
                    name: Clouds.PAY_AS_YOU_GO,
                    fieldType: FilterType.DROPDOWN_GROUP_MULTIPLE,
                    groupBy: 'group',
                    required: false,
                    apiInfo: this.listHttpService.azurePayAsYouGoAccountIds,
                    value: this.edit ? this.selectedPayAsYouGoAccountIds : null
                }
            ]
        };
        this.checkBoxFormGenInput = {
            formName: '',
            submitButton: null,
            state: FormState.CREATE,
            fields: [
                {
                    label: 'Send',
                    placeholder: '',
                    name: 'send',
                    fieldType: FilterType.CHECKBOX,
                    value: true
                }
            ]
        };
        this.cdr.detectChanges();
        this.emailContentFormGenInputs = {
            formName: '',
            submitButton: null,
            state: FormState.CREATE,
            fields: [
                {
                    label: 'Subject',
                    placeholder: '',
                    name: 'subject',
                    fieldType: FilterType.TEXT,
                    value: this.emailSubject ? this.emailSubject : '',
                    required: true,
                    validations: [
                        {
                            validator: CustomValidators.required,
                            errorMessage: 'Email Subject is required'
                        }
                    ]
                },
                {
                    label: 'Email Content',
                    placeholder: '',
                    name: 'emailContent',
                    fieldType: FilterType.WYSIWYG_EDITOR,
                    value: this.emailContent ? this.emailContent : ''
                }
            ]
        };
    }
    createUser(buttonRef: IButtonGeneratorInput) {
        if (buttonRef.loader) {
            return;
        }
        if (
            this.checkBoxFormGenInput &&
            this.checkBoxFormGroup.value &&
            this.checkBoxFormGroup.value.send
        ) {
            Helper.markAllFieldAsTouched(this.emailContentFormGroup);
            if (this.emailContentFormGroup.invalid) {
                this.emailContentFormGroup.updateValueAndValidity();
                return;
            }
        }

        buttonRef.loader = true;
        const apiConf: IHitApi = {
            url: ApiUrls.USERS_END_POINT,
            input: this.prepareInputs(),
            function: (response) => {
                buttonRef.loader = false;
                this.notificationService.showSnackBar(
                    'User created successfully'
                );
                this.filtersService.refreshWidget.next(
                    new Set([this.modalService.modalData.sourceId])
                );

                this.modalService.closeModal(null, this.modalInputData.modalId);
            },
            requestType: RequestType.POST,
            uniqueIdentity: Symbol(),
            config: {
                authorization: AuthorizationType.BEARER_TOKEN
            },
            errorFunction: (error) => {
                buttonRef.loader = false;
                Helper.showErrorMessage(
                    this.notificationService,
                    error,
                    'Error while creating user'
                );
                this.modalService.closeModal(null, this.modalInputData.modalId);
            }
        };

        new HitApi(apiConf, this.listHttpService, this.ngZone).hitApi();
    }
    prepareInputs() {
        const data = this.emailContentFormGroup.value;
        const step1Data = this.multiStepFormService.stepData
            .get(this.modalInputData.modalId)
            .get(1);

        const viewIds = [];
        step1Data['userViewIds'].forEach((ele) => {
            viewIds.push(ele['id']);
        });
        const inputs = {
            firstName: step1Data.firstName,
            lastName: step1Data.lastName,
            viewIds: viewIds,
            notifyWithEmail: false,
            password: step1Data.password,
            confirmPassword: step1Data.password,
            defaultViewId: step1Data.defaultView,
            email: step1Data.email,
            phoneNumber: step1Data.phoneNumber,
            sendingMechanism: {
                sendViaEmail: this.checkBoxFormGroup.value.send,
                emailRequest: {
                    emailTo: [step1Data.email],
                    subject: data.subject,
                    emailBody: data.emailContent
                }
            }
        };
        inputs['cloudAccounts'] = {
            aws: this.accountListFormGroup.get(Clouds.AWS).value,
            'azure-csp': this.accountListFormGroup.get(Clouds.AZURE_CSP).value,
            'azure-plan': this.accountListFormGroup.get(Clouds.AZURE_PLAN)
                .value,
            'azure-ea': this.accountListFormGroup.get(Clouds.AZURE_EA).value,
            'azure-mca': this.accountListFormGroup.get(Clouds.AZURE_MCA).value,
            'azure-pay-as-you-go': this.accountListFormGroup.get(
                Clouds.PAY_AS_YOU_GO
            ).value,
            'azure-sponsorship': this.accountListFormGroup.get(
                Clouds.SPONSORSHIP
            ).value
        };
        return inputs;
    }
    updateUser(buttonRef: IButtonGeneratorInput) {
        if (buttonRef.loader) {
            return;
        }
        buttonRef.loader = true;
        const input = this.prepareInputsToUpdate();
        input['viewIds'] = input['userViewIds'];
        delete input['userViewIds'];
        input['cloudAccounts'] = {
            aws: this.accountListFormGroup.get(Clouds.AWS).value,
            'azure-csp': this.accountListFormGroup.get(Clouds.AZURE_CSP).value,
            'azure-plan': this.accountListFormGroup.get(Clouds.AZURE_PLAN)
                .value,
            'azure-ea': this.accountListFormGroup.get(Clouds.AZURE_EA).value,
            'azure-mca': this.accountListFormGroup.get(Clouds.AZURE_MCA).value
        };
        const apiConf: IHitApi = {
            url: `${ApiUrls.USERS_END_POINT}/${this.stepData['id']}`,
            input: input,
            function: (response) => {
                buttonRef.loader = false;
                this.notificationService.showSnackBar(
                    'User updated successfully'
                );
                this.filtersService.refreshWidget.next(
                    new Set([this.modalService.modalData.sourceId])
                );

                this.modalService.closeModal(null, this.modalInputData.modalId);
            },
            intactUrl: `${ApiUrls.USERS_END_POINT}/{id}`,
            requestType: RequestType.PUT,
            uniqueIdentity: Symbol(),
            config: {
                authorization: AuthorizationType.BEARER_TOKEN
            },
            errorFunction: (error) => {
                buttonRef.loader = false;
                Helper.showErrorMessage(
                    this.notificationService,
                    error,
                    `Error while updating user`
                );
            }
        };
        new HitApi(apiConf, this.listHttpService, this.ngZone).hitApi();
    }
    prepareInputsToUpdate() {
        const viewIds = [];
        const form = this.multiStepFormService.stepData
            .get(this.modalInputData.modalId)
            .get(1);
        form.userViewIds.forEach((view) => {
            viewIds.push(view['id']);
        });
        const input = {
            firstName: form.firstName,
            lastName: form.lastName,
            userViewIds: viewIds,
            notifyWithEmail: false,
            password: form.password,
            confirmPassword: form.confirmPassword,
            defaultViewId: form.defaultView,
            email: form.email,
            phoneNumber: form.phoneNumber
        };
        return input;
    }
}
